import {
  IGIcon,
  TikTokIcon,
  SnapChatIcon,
  TwitterIcon,
  LinkedinIcon,
} from "../../../../assets/icons";
import { YoutubeIcon } from "../../../../components/icons";
import SharePage from "../SharePageWidget";
import UserInfo from "../../../../components/UserInfo";

export const socialLog: any = {
  instagram: <IGIcon />,
  tiktok: <TikTokIcon />,
  snapchat: <SnapChatIcon />,
  "x (twitter)": <TwitterIcon />,
  youtube: <YoutubeIcon />,
  linkedin: <LinkedinIcon />,
};

const AboutHeader = ({ data, username, jollofPage }: any) => {
  return (
    <section className="w-full flex flex-col md:flex-row justify-between md:items-center mt-5 md:mt-0">
      <div className="flex flex-col gap-3">
        <UserInfo
          size="large"
          withImage={true}
          title={data?.name}
          userName={data?.username}
          subTitle={data?.about}
          hasWidth={true}
          categories={data?.categories}
          url={data?.profileImage ? data?.profileImage?.url : ""}
        />
        <p className="font-gt-w-regular text-sm  text-black-100 tracking-tight m-0 p-0">
          {data?.about}
        </p>
      </div>

      <div className="flex items-center gap-4 mt-4 md:mt-5 lg:mt-0 xl:mt-0">
        <div className="flex md:hidden">
          {data?.socialMedia && Object.keys(data?.socialMedia).length > 0 && (
            <section className="flex items-center gap-2">
              {Object.entries(data?.socialMedia).map(([platform, handle]) => {
                const IconComponent = socialLog[platform.toLowerCase()];

                if (!IconComponent) return null;

                // Build the URL based on the platform
                const getUrl = (platform: any, handle: any) => {
                  const baseUrls = {
                    instagram: "https://instagram.com/",
                    tiktok: "https://tiktok.com/@",
                    snapchat: "https://snapchat.com/add/",
                    "x (twitter)": "https://twitter.com/",
                    youtube: "https://youtube.com/@",
                    linkedin: "https://linkedin.com/in/",
                  };

                  const baseUrl =
                    baseUrls[platform.toLowerCase() as keyof typeof baseUrls];
                  return baseUrl ? `${baseUrl}${handle}` : `https://${handle}`;
                };

                return (
                  <a
                    key={platform}
                    href={getUrl(platform, handle)}
                    target="_blank"
                    rel="noreferrer"
                    className="w-8 h-8 rounded-md flex justify-center items-center bg-black-100 hover:opacity-80 transition-opacity"
                  >
                    {IconComponent}
                  </a>
                );
              })}
            </section>
          )}
        </div>
        <SharePage username={username} plateName={jollofPage?.plateName} />
      </div>
    </section>
  );
};

export default AboutHeader;
